import { memo } from 'react';
import Header from 'containers/components/layouts/Header';
import HeaderTitle from 'containers/components/layouts/HeaderTitle';
import HeaderSection from 'containers/components/layouts/HeaderSection';
import HeaderSectionDefault from 'containers/components/layouts/HeaderSectionDefault';

const MetricsHeader = memo(() => {
    return (
        <Header>
            <HeaderSection>
                <HeaderTitle title="label_metrics_and_reports" />
            </HeaderSection>
            <HeaderSectionDefault />
        </Header>
    );
});

export default MetricsHeader;
